import i18n from "i18next";
import includes from "lodash/includes";
import each from "lodash/each";
import { initReactI18next } from "react-i18next";

import enGb from "./en-GB";
import { DateTime } from "luxon";
import * as dateTimeFormats from "../constants/dateTimeFormats";

function formatDateTime(value, format, lng) {
  const datTime = DateTime.fromISO(value);
  if (!datTime.isValid) {
    console.warn("Invalid date", value);
    return null;
  }
  return datTime.setLocale(lng).toLocaleString(DateTime[format]);
}

function formatRelativeDateTime(value, lng) {
  const datTime = DateTime.fromISO(value);
  if (!datTime.isValid) {
    console.warn("Invalid date", value);
    return null;
  }
  return datTime.setLocale(lng).toRelative();
}

function formatCurrency({ amount, currency = {} } = {}, lng) {
  const smallestUnitFactor = Math.pow(10, currency.decimal);

  const value = amount / smallestUnitFactor;
  return new Intl.NumberFormat(lng, {
    style: "currency",
    currency: currency.id,
  })
    .formatToParts(value)
    .map(({ type, value }) => {
      switch (type) {
        case "currency":
        case "literal":
          return "";
        default:
          return value;
      }
    })
    .reduce((string, part) => string + part);
}

i18n.use(initReactI18next).init({
  resources: [],
  lng: "en-GB",
  // TODO: re-enable before starting to support other languages
  // debug: process.env.NODE_ENV || process.env.NODE_ENV === "development",
  debug: false,
  interpolation: {
    escapeValue: false,
    format: function (value, format, lng) {
      if (includes(dateTimeFormats, format)) {
        return value ? formatDateTime(value, format, lng) : null;
      }
      switch (format) {
        case "RELATIVE_DATE_TIME":
          return formatRelativeDateTime(value, lng);
        case "CURRENCY":
          return formatCurrency(value, lng);
        default:
          return value;
      }
    },
  },
});

each(enGb, (translations, key) => {
  i18n.addResourceBundle("en-GB", key, translations);
});
